import Delay from "@/utils/common/delay";
import nfetch from "@/utils/events/nfetch";

import ProdutoModel from "../../models/produto/produtoModel";
import { iServiceCached } from "../base/iServiceCached";

class ProdutoESinonimosService extends iServiceCached<ProdutoModel> {
    constructor() {
        super("Produto");
    }

    public async comboCached(franquiaId: number, refresh = false) {
        while (this.loadingCache) await Delay(100);

        if (this.cached[franquiaId] && !refresh) {
            return this.cached[franquiaId];
        }

        this.loadingCache = true;
        try {
            const response = await nfetch(`/${this.controllerName}/ListWithSinonimo?franquiaId=${franquiaId}`, {
                credentials: "same-origin",
            })
                .withLoading()
                .resolveWithJSON<Promise<ProdutoModel[]>>();
            this.cached[franquiaId] = response;

            return response;
        } catch {
        } finally {
            this.loadingCache = false;
        }
    }
}

export default new ProdutoESinonimosService();
